<template>
  <div class="success-content">
    <div class="icon-wrapper">
      <slot name="icon">
       
      </slot>
    </div>
    
    <h2 class="main-title">{{ mainTitle }}</h2>
    
    <div class="hints">
         <p v-for="(hint, index) in hints" :key="index" class="hint-item">
           {{ Object.prototype.toString.call(hint)=== '[object Object]'?`${hint.label}${hint.value ? '：' + hint.value : ''}` : hint }}
        
         </p>
    </div>
    
    <button class="confirm-btn" @click="handleConfirm">
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'SuccessContent',
  props: {
    mainTitle: {
      type: String,
      default: '您的车辆可升级OTA'
    },
    hints: {
      type: Array,
      default: () => [
      ]
    },
    buttonText: {
      type: String,
      default: '确认'
    },
    confirmMethod: {
      type: Function,
      default: null
    }
  },
  methods: {
    handleConfirm() {
      if (this.confirmMethod && typeof this.confirmMethod === 'function') {
        this.confirmMethod()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import './common.less';

.success-content {
  .form-wrapper();
}

.icon-wrapper {
  .success-fail-icon-wrapper();
}

.main-title {
  .success-fail-main-title();
}

.hints {
  .success-fail-hints();
}

.confirm-btn {
  .success-fail-button();
}
</style>
